import Lenis from '@studio-freight/lenis'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

export let lenisScroll = null

const smoothScroll = {
  init(): void {
    lenisScroll = new Lenis({
      lerp: 0.1,
    })

    function raf(time) {
      lenisScroll.raf(time)
      requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)

    // this.integrateScrollTrigger()
  },

  integrateScrollTrigger(): void {
    // Optional, not needed. If used it breaks down smooth scroll on first page load, but doesn't really affect scroll performance.

    gsap.registerPlugin(ScrollTrigger)

    lenisScroll.on('scroll', ScrollTrigger.update)

    gsap.ticker.add((time) => {
      lenisScroll.raf(time * 1000)
    })

    gsap.ticker.lagSmoothing(0)
  },
}

export default smoothScroll
